import { PersonaRequest } from '../interfaces/Persona'
import { POSTWithAuth } from './Index'

export async function PersonaVerify(user_id: string, inquiry_id: string): Promise<void> {
  return await POSTWithAuth<PersonaRequest, void>(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/users/${user_id}/persona`,
    {
      inquiry_id,
    }
  )
}
